export function tagsFun(customTags, setTagsArray, tagsArray, setCustomTags) {
    const handleAddTag = () => {
        const input = customTags.trim();
        if (input === '') return;

        // . , ; символдары арқылы бөлеміз
        const rawTags = input.split(/[.,;]+/);

        const validNewTags = [];

        for (const rawTag of rawTags) {
            const tag = rawTag.trim();

            // Тег 2 немесе одан да көп символдан тұруы керек
            const isValid = tag.length >= 2;

            // Егер тег жарамды және бұрын қосылмаған болса
            if (isValid && !tagsArray.includes(tag)) {
                validNewTags.push(tag);
            }
        }

        if (validNewTags.length > 0) {
            setTagsArray(prev => [...prev, ...validNewTags]);
        }

        setCustomTags('');
    };

    const handleRemoveTag = (index) => {
        setTagsArray(tagsArray.filter((_, i) => i !== index));
    };
    return { handleAddTag, handleRemoveTag };
}